export default __webpack_public_path__ + "static/media/2.e21d8ffc.png";